import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiCdkNoDragDirective } from './fi-cdk-no-drag.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [FiCdkNoDragDirective],
    exports: [FiCdkNoDragDirective],
})
export class FiCdkNoDragModule {}
